export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4038f0df6e4d875c733819e5a0e5e5227bf2ee3cc2&name=revalidateCommunity!'